define.alias("shared/components/shared/post/secondary/caption-writer/list", "settings/components/shared/post/secondary/caption-writer/list");